module.exports = __webpack_public_path__ + "static/media/it-square.4a765d5f.jpg";